import { render } from "./ReportDesc.vue?vue&type=template&id=500d2378&scoped=true"
import script from "./ReportDesc.vue?vue&type=script&lang=js"
export * from "./ReportDesc.vue?vue&type=script&lang=js"

import "./ReportDesc.vue?vue&type=style&index=0&id=500d2378&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500d2378"]])

export default __exports__